<script setup lang="ts">
import { useModalStore } from '@/stores/apostatudo/modal';

const { isOpen, component, props } = storeToRefs(useModalStore());
const { close } = useModalStore();
</script>

<template>
  <Teleport to="body">
    <HeadlessTransitionRoot
      class="fixed inset-0 z-[999] flex items-start justify-center bg-black/75 w-dvw h-dvh"
      enter="transition"
      enter-from="opacity-0"
      enter-to="opacity-100 "
      leave="transition"
      leave-from="opacity-100"
      leave-to="opacity-0"
      :show="isOpen"
    >
      <component
        :is="component"
        v-bind="props"
        @close="close"
      />
    </HeadlessTransitionRoot>
  </Teleport>
</template>
